import React from 'react';
import { View, ScrollView, Text, StyleSheet } from 'react-native';
import { TopBar } from '../components/TopBar';
import { StatCard } from '../components/StatCard';
import { AppointmentsList } from '../components/AppointmentsList';
import { colors, globalStyles } from '../styles/global';

export const DashboardScreen = () => {
  // Dados mockados para exemplo
  const stats = [
    { title: 'Clientes Ativos', value: '157', icon: '👥' },
    { title: 'Agendamentos Hoje', value: '12', icon: '📅' },
    { title: 'Faturamento', value: 'R$ 3.2k', icon: '💰' },
    { title: 'Taxa de Presença', value: '95%', icon: '📊' },
  ];

  const appointments = [
    { client: 'Maria Silva', time: '14:00', service: 'Corte', status: 'confirmado' },
    { client: 'João Santos', time: '15:30', service: 'Barba', status: 'pendente' },
    { client: 'Ana Paula', time: '16:45', service: 'Coloração', status: 'confirmado' },
  ];

  return (
    <View style={styles.container}>
      <TopBar 
        userName="Rafael"
        onNotificationPress={() => {}}
        onProfilePress={() => {}}
      />
      
      <ScrollView style={styles.content}>
        <View style={styles.welcomeCard}>
          <Text style={styles.welcomeTitle}>Bem-vindo de volta!</Text>
          <Text style={styles.welcomeSubtitle}>
            Você tem {appointments.length} agendamentos hoje
          </Text>
        </View>

        <Text style={styles.sectionTitle}>Visão Geral</Text>
        <ScrollView 
          horizontal 
          showsHorizontalScrollIndicator={false}
          style={styles.statsContainer}
        >
          {stats.map((stat, index) => (
            <View key={index} style={styles.statCardWrapper}>
              <StatCard {...stat} onPress={() => {}} />
            </View>
          ))}
        </ScrollView>

        <View style={styles.appointmentsContainer}>
          <AppointmentsList 
            appointments={appointments}
            onSeeAll={() => {}}
          />
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  content: {
    flex: 1,
    padding: 20,
  },
  welcomeCard: {
    backgroundColor: colors.white,
    borderRadius: 10,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  welcomeTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 5,
  },
  welcomeSubtitle: {
    fontSize: 16,
    color: colors.textLight,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 15,
  },
  statsContainer: {
    marginBottom: 20,
  },
  statCardWrapper: {
    marginRight: 15,
  },
  appointmentsContainer: {
    marginBottom: 20,
  },
});